import React from 'react';
import { useGetReturnRequestByOrderItemQuery } from '../../../redux/apis/endpoints/requestApi';
import ReturnItemInfo from '../../actions/shared/ReturnItemInfo';

const ReturnItemRow = ({ item }) => {
  // Only fetch return request data if we have a valid item ID
  // and don't already have the return request data
  const shouldSkipQuery = !item?.id || 
                        !Number.isFinite(Number(item.id)) ||
                        !!item.returnRequest?.reason || 
                        !!item.returnRequest?.requestDetails?.reason;
  
  const { data: reqData } = useGetReturnRequestByOrderItemQuery(
    Number.isFinite(Number(item.id)) ? item.id : undefined,
    {
      skip: shouldSkipQuery,
      refetchOnMountOrArgChange: false
    }
  );

  return <ReturnItemInfo item={item} />;
};

export default ReturnItemRow; 